import { render } from "./ActivityIcon.vue?vue&type=template&id=4227b07d"
const script = {}

import exportComponent from "/codebuild/output/src3420118497/src/halter-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__